/** Lifecycle phases shared by landing pages, intake handoff, and confirmation views. */
export const LIFECYCLE_PATHS = {
  start: "/landing/",
  landing: "/landing/",
  horizon: "/landing/horizonscanning/",
  obligations: "/landing/obligations/",
  gap: "/landing/gapanalysis/",
  horizonPhase: "/landing/horizonscanning/",
} as const;

export const OFFER_COPY = {
  freePreview: "Free preview on your own document",
  freeWeek: "Free week of weekly digests",
} as const;

export function nextPhaseAfterOffer(offerId: string): {
  href: string;
  linkText: string;
  suffix: string;
} {
  if (offerId === "obligations-export") {
    return {
      href: LIFECYCLE_PATHS.gap,
      linkText: "When your SOPs are ready, run the gap analysis",
      suffix: OFFER_COPY.freePreview,
    };
  }
  return {
    href: LIFECYCLE_PATHS.horizonPhase,
    linkText: "Watch the sources behind that regulation with horizon scanning",
    suffix: OFFER_COPY.freeWeek,
  };
}

export const HORIZON_NEXT_PHASE = {
  href: LIFECYCLE_PATHS.obligations,
  linkText: "Extract the obligations from a publication this digest surfaced",
  suffix: OFFER_COPY.freePreview,
} as const;
